// Angular imports
import { HttpClient } from '@angular/common/http';
// 3rd party imports
import { classToPlain, plainToClass } from 'class-transformer';
// RxJs imports
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';
// Service imports
import { MPCacheRegistrationService } from '../../_services/shared-services/mp-cache-registration-service';
// constant imports
import { CacheDuration } from './../../_constants/cache-duration';
import { URLConstants } from '../../_constants/url-constants';
import { WFESpecialHandlingResultDto } from '../_models/wfe-special-handling-result-dto';
import { WorkflowChecklistEditorResultDto } from '../_models/workflow-check-list-editor-result-dto';
import { VendorCodingDefaultEditorResultDto } from '../_models/vendor-coding-default-editor-result-dto';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../_services/shared-services/mp-cache-registration-service";
export class WorkflowEditorSharedService {
    constructor(httpClient, cacheRegistrationService) {
        this.httpClient = httpClient;
        this.cacheRegistrationService = cacheRegistrationService;
        this._subjectIsDefaultLineItemAvailable = new Subject();
    }
    getWorkflowSpecialHandling(baseParams) {
        const url = `${URLConstants.ccWorkflowEditorBaseApiUrl}specialhandlings${baseParams.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, baseParams.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((response) => plainToClass(WFESpecialHandlingResultDto, response)));
    }
    getCodingDefaultEditor(baseParams, workflowStep) {
        const url = `${URLConstants.ccWorkflowEditorBaseApiUrl}${workflowStep}/coding-default/editor${baseParams.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((response) => plainToClass(VendorCodingDefaultEditorResultDto, response)));
    }
    saveCodingDefaultEditor(baseParams, workflowStep) {
        return this.httpClient.post(`${URLConstants.ccWorkflowEditorBaseApiUrl}${workflowStep}/coding-default`, classToPlain(baseParams));
    }
    isDefaultLineItemAvailable() {
        return this._subjectIsDefaultLineItemAvailable;
    }
    updateLineItemAvailability(value) {
        this._subjectIsDefaultLineItemAvailable.next(value);
    }
    getWorkflowChecklistEditor(baseParams, workflowStep) {
        const url = `${URLConstants.ccWorkflowEditorBaseApiUrl}${workflowStep}/checklist/editor${baseParams.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((response) => plainToClass(WorkflowChecklistEditorResultDto, response)));
    }
    saveWorkflowChecklist(baseParams, workflowStep) {
        return this.httpClient.post(`${URLConstants.ccWorkflowEditorBaseApiUrl}${workflowStep}/checklist`, classToPlain(baseParams));
    }
    getWorkflowAccountantChecklistEditor(baseParams) {
        const url = `${URLConstants.ccWorkflowEditorBaseApiUrl}acct/checklist/editor${baseParams.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, baseParams.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((response) => plainToClass(WorkflowChecklistEditorResultDto, response)));
    }
    saveWorkflowAccountantChecklist(baseParams) {
        return this.httpClient.post(`${URLConstants.ccWorkflowEditorBaseApiUrl}acct/checklist`, classToPlain(baseParams));
    }
    reclassBill(baseParams, workflowStep) {
        return this.httpClient.put(`${URLConstants.ccWorkflowEditorBaseApiUrl}${workflowStep}/reclass-bill`, classToPlain(baseParams));
    }
    updateBill(baseParams, workflowStep) {
        return this.httpClient.put(`${URLConstants.ccWorkflowEditorBaseApiUrl}${workflowStep}/update-bill`, classToPlain(baseParams));
    }
    updateVendorAccountEFT(baseParams) {
        return this.httpClient.put(`${URLConstants.ccWorkflowEditorBaseApiUrl}vendor-account/eft`, classToPlain(baseParams));
    }
}
WorkflowEditorSharedService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function WorkflowEditorSharedService_Factory() { return new WorkflowEditorSharedService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.MPCacheRegistrationService)); }, token: WorkflowEditorSharedService, providedIn: "root" });
